import React from "react";
import "./ButtonSecondary.css";

function ButtonSecondary(props) {
  return (
    <a className="button-secondary" href={props.href}>
      <img src={`assets/icons/${props.image}`} alt={props.alt} />
      {props.tittle}
    </a>
  );
}

export default ButtonSecondary;
